<template>
	<div class="JsonDefaultRaw" :class="{ error }">
		<textarea id="defaultValue" class="input" rows="4"
			v-model="model"
			placeholder="Default value (JSON format)"
			:style="{ borderColor: error ? 'var(--error)' : '' }"
		></textarea>
		<div v-if="error" class="error">{{ error }}</div>
	</div>
</template>

<script>
export default {
	name: 'JsonDefaultRaw',
	props: {
		value: [ Object, Array, String, Number, Boolean ],
		field: Object,
		entry: Object,
		control: Object,
	},
	data: () => ({
		model: null,
		autoModel: false,
		error: null,
	}),
	watch: {
		value(n) {
			this.model = JSON.stringify(n)
		},
		model(n, o) {
			this.error = null
			if (n) {
				if (n == o) return
				if (n == JSON.stringify(this.value)) return
				try {
					const v = JSON.parse(n)
					this.$emit('input', v)
				}
				catch (e) {
					this.error = e.message
				}
			}
		},
	},
	mounted() {
		this.model = JSON.stringify(this.value)
	},
}
</script>

<style scoped>
textarea.input { font-family: monospace; height: 100px; min-height: 50px; max-height: 400px; min-width: 100%; max-width: 100%; }
.error { color: rgb(189, 0, 43); margin-top: 5px; }
</style>
